"use client";

import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { useMediaQuery } from "@react-hookz/web";
import { type CSSProperties, useMemo } from "react";
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { breakpoints, type ClassValue, cn } from "@repo/lib";
import { GenericPage_Article_Fragment } from "./graphql";
export function Article({
  children,
  className,
  pageMasked
}: {
  children?: React.ReactNode;
  className?: string;
  pageMasked: FragmentOfShopifyStorefront<typeof GenericPage_Article_Fragment>;
}) {
  const page = readFragmentShopifyStorefront(GenericPage_Article_Fragment, pageMasked);
  const mediaQueries = {
    sm: useMediaQuery(`only screen and (min-width : ${breakpoints?.sm?.min?.toString() ?? "0"})`),
    md: useMediaQuery(`only screen and (min-width : ${breakpoints?.md?.min?.toString() ?? "0"})`),
    lg: useMediaQuery(`only screen and (min-width : ${breakpoints?.lg?.min?.toString() ?? "0"})`),
    xl: useMediaQuery(`only screen and (min-width : ${breakpoints?.xl?.min?.toString() ?? "0"})`),
    "2xl": useMediaQuery(`only screen and (min-width : ${breakpoints?.["2xl"]?.min?.toString() ?? "0"})`)
  };

  // FIX: Replaced useState and useEffect with useMemo to derive the style object
  const style = useMemo<CSSProperties>(() => {
    const stylesToMerge = [page?.style?.value, mediaQueries.sm && page?.styleSm?.value, mediaQueries.md && page?.styleMd?.value, mediaQueries.lg && page?.styleLg?.value,
    // Corrected to be conditional on mediaQueries.lg
    mediaQueries.xl && page?.styleXl?.value].filter(Boolean).map(s => JSON.parse(s as string) as CSSProperties);

    // Merge all applicable styles.
    // Object.assign({}, ...stylesToMerge) returns a new object combining all styles.
    return Object.assign({}, ...stylesToMerge);
  }, [mediaQueries.sm, mediaQueries.md, mediaQueries.lg, mediaQueries.xl, page?.style?.value, page?.styleSm?.value, page?.styleMd?.value, page?.styleLg?.value, page?.styleXl?.value]);
  return <article className={cn("grid snap-y snap-start", page?.classes?.value && JSON.parse(page.classes.value) as ClassValue, className)} style={style}>
      {children}
    </article>;
}